// src/components/common/Button.jsx
// Reusable button component with multiple variants

import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  disabled = false,
  onClick,
  type = 'button',
  className = '',
}) => {
  const baseStyles = 'font-bold transition-all rounded-full shadow-lg hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-gradient-to-r from-teal-700 to-cyan-500 text-white hover:shadow-teal-700/50 dark:from-teal-500 dark:to-cyan-400 dark:text-black',
    secondary: 'bg-white text-gray-900 border-4 border-gray-200 hover:border-teal-700 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700',
    gradient: 'bg-gradient-to-r from-teal-700 to-cyan-500 text-white dark:from-teal-500 dark:to-cyan-400 dark:text-black',
    outline: 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-200 dark:hover:text-gray-900',
  };

  const sizes = {
    small: 'px-6 py-2 text-sm',
    medium: 'px-8 py-3 text-base',
    large: 'px-10 py-5 text-lg',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
